import axios from "axios";

const getCompanyList = async () => {
  try {
    const response = await axios.get(
      "/consumer/system-admin/api/v1/data-summary/company-list",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    const errorResponse = {
      success: false,
      error: error.response?.data?.message || error.message,
      code: error.response?.data?.code || "ERROR_UNKNOWN",
      data: [],
      details: error.response?.data?.data || null,
    };
    console.error("API Error Details:", errorResponse);
    throw errorResponse;
  }
};

export default getCompanyList;
